module.exports = __webpack_public_path__ + "d8b06e044316f2af114737a690de2fa2.svg";